export default __webpack_public_path__ + "static/a_francke-0c9c519b65e8a0472dec0884f326aef0.jpg";